import { types as t } from 'mobx-state-tree';
import { useCreateStore, useProvider, useStore } from 'mobx-store-provider';
import * as React from 'react';

export const DolStoryStore = t
  .model('DolStoryStore', {
    currentActiveIndex: t.optional(t.number, -1),
    modalVisible: t.optional(t.boolean, false),
  })
  .volatile(() => ({
    data: null,
  }))
  .actions((self) => ({
    registerData(data) {
      self.data = data;
    },
    nextSlide() {
      if (!self.modalVisible) return;
      if (self.currentActiveIndex >= self.data.length - 1) {
        self.currentActiveIndex = self.data.length - 1;
        return;
      }
      self.currentActiveIndex += 1;
    },
    prevSlide() {
      if (!self.modalVisible) return;
      if (self.currentActiveIndex <= 0) {
        self.currentActiveIndex = 0;
        return;
      }
      self.currentActiveIndex -= 1;
    },
    openModal(slideIndex) {
      self.currentActiveIndex = slideIndex;
      self.modalVisible = true;
    },
    closeModal() {
      self.modalVisible = false;
    },
  }))
  .actions((self) => ({}));

export const useDolStoryStore = () => {
  return useStore(DolStoryStore);
};

export const withDolStoryStore = (Component: any) => (props: any) => {
  const dolEditorCreateStore = useCreateStore(DolStoryStore, {});
  const DolStoryStoreProvider = useProvider(DolStoryStore);

  return (
    <DolStoryStoreProvider value={dolEditorCreateStore}>
      <Component {...props} />
    </DolStoryStoreProvider>
  );
};
